import React from 'react';

import { NodeProps } from './shared';

interface HeadingNodeProps extends NodeProps {
  type: 'h1' | 'h2' | 'h3';
}

const getHeadingClasses = (type: 'h1' | 'h2' | 'h3'): string => {
  const baseClasses = 'font-medium mt-6 mb-3 tablet:mt-8 tablet:mb-4';

  const typeClasses = {
    h1: 'text-[2.125rem] leading-[2.25rem] tablet:text-[3.125rem] tablet:leading-[3.4375rem]',
    h2: 'text-[1.75rem] leading-[2rem] tablet:text-[2.625rem] tablet:leading-[3rem]',
    h3: 'text-[1.375rem] leading-[1.5rem] tablet:text-[1.625rem] tablet:leading-[2rem]'
  };

  return `${baseClasses} ${typeClasses[type]}`;
};

export function HeadingNode({ children, type }: HeadingNodeProps) {
  const HeadingTag = type;

  return (
    <HeadingTag className={getHeadingClasses(type)}>{children}</HeadingTag>
  );
}
